import is from "../utils/is";

class LocalStorage {
  _getItem = (keyName) => {
    const keyValue = sessionStorage.getItem(keyName);
    if (is.null(keyValue) || is.undefined(keyValue)) return keyValue;
    const keyValue_ = Uint8Array.from(window.atob(keyValue), (m) => m.codePointAt(0)) ;
    return JSON.parse(new TextDecoder().decode(keyValue_));
  };
  _setItem = (keyName, keyValue) => {
    const encodeString = new TextEncoder().encode(JSON.stringify(keyValue));
    const keyValue_ = Array.from(encodeString, (byte) =>
      String.fromCodePoint(byte),
    ).join("");
    return sessionStorage.setItem(keyName, window.btoa(keyValue_));
  };
  _removeItem = (keyName) => {
    sessionStorage.removeItem(keyName);
  };
  _clear = () => {
    sessionStorage.clear();
  };
}

class Storage extends LocalStorage {
  subscribers = {};

  /**
   *
   * @param {string} keyName
   * @returns
   */
  getItem = (keyName) => {
    return this._getItem(keyName);
  };

  /**
   *
   * @param {string} keyName
   * @param {*} keyValue
   * @returns
   */
  setItem = (keyName, keyValue) => {
    if (is.undefined(keyName)) {
      throw new Error("keyName should not be undefined");
    }
    this._setItem(keyName, keyValue);
    this.emit(keyName);
  };

  /**
   *
   * @param {string} keyName
   */
  removeItem = (keyName) => {
    if (is.undefined(keyName)) {
      //Do nothing
    } else {
      this._removeItem(keyName);
      this.emit(keyName);
    }
  };

  clear = () => {
    this._clear();
  };

  /**
   *
   * @param {string} keyName
   */
  emit = (keyName) => {
    let subscribers = this.subscribers[keyName] || [];
    subscribers.forEach((subscriber) => {
      let value = this._getItem(keyName);
      subscriber(value);
    });
  };

  /**
   *
   * @param {string} keyName
   * @param {function} cb
   */
  addChangeListener = (keyName, cb) => {
    if (this.subscribers[keyName]) {
      this.subscribers[keyName].push(cb);
    } else {
      this.subscribers[keyName] = [cb];
    }
  };

  /**
   *
   * @param {string} keyName
   * @param {function} cb
   */
  removeChangeListener = (keyName, cb) => {
    this.subscribers[keyName] = this.subscribers[keyName].filter((callBack) => cb !== callBack);
  };
}
const storage = new Storage();
export default storage;
